import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubscriptionInfoStore, SubscriptionsInfo } from './types';
import { fetchSubscriptionsInfo } from './thunk';

const initialState: SubscriptionInfoStore = {
  data: null,
  loading: 'idle',
};

export const subscriptionsInfo = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    resetSubscriptionsInfo: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSubscriptionsInfo.pending, (state) => {
      state.loading = 'pending';
    });
    builder.addCase(fetchSubscriptionsInfo.fulfilled, (state, action: PayloadAction<SubscriptionsInfo>) => {
      state.data = action.payload;
      state.loading = 'succeeded';
    });
  },
});

export const { resetSubscriptionsInfo } = subscriptionsInfo.actions;
export default subscriptionsInfo.reducer;
